export default __webpack_public_path__ + "static/media/TTCommons-Medium.06c8c841.woff";